import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';
import {DotsMenu} from '@mintdata-wsp/wsp/ui/components/menus/DotsMenu';
import {MenuItem} from '@mintdata-wsp/wsp/ui/components/menus/MenuItem';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./DataLine.less');
const cx = classnames.bind(styles);

export interface DataLineProps
{
    className?:string;
    menuItems?:MenuItem[];
    colorType?:DataLineColorType;
    isNewLine?:boolean;
    hideMenu?:boolean;
}

export enum DataLineColorType
{
    Red = 1,
    Green = 2,
    Orange = 3,
    Dark = 4,
    Gray = 5,
    Blue = 6,
}

@observer
export class DataLine extends React.Component<DataLineProps, any>
{
    render()
    {
        const {
            menuItems,
            colorType = DataLineColorType.Dark,
            isNewLine = false,
            className,
            hideMenu = false,
        } = this.props;

        const colorTypeStr = 'colorType-' + DataLineColorType[colorType];

        return (
            <Row className={cx('dataLine', {isNewLine}, colorTypeStr, className)}>

                <Row className={cx('children')}>
                    {this.props.children}
                </Row>

                {!hideMenu && menuItems && (
                    <Row className={cx('menu', {isDisabled: !menuItems.length})}>
                        <DotsMenu
                            menuItems={menuItems}
                            className={styles.menuBase}
                            popupClassName={styles.menuPopup}
                        />
                    </Row>
                )}

            </Row>
        );
    }
}
